
import { useUserPreferences } from "@/contexts/UserPreferencesContext";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export function ThemeSwitcher() {
    const { preferences, updatePreference, availableThemes } = useUserPreferences();

    return (
        <div className="grid grid-cols-2 gap-4">
            {Object.values(availableThemes).map((theme) => (
                <Button
                    key={theme.name}
                    variant="outline"
                    className={`relative h-20 w-full overflow-hidden border-2 transition-all hover:scale-105 ${preferences.theme === theme.name ? "border-primary ring-2 ring-primary/20" : "border-border"
                        }`}
                    onClick={() => updatePreference("theme", theme.name)}
                >
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-background/50 to-background/80 p-2 backdrop-blur-sm">
                        <div className="flex gap-1.5">
                            <div
                                className="h-4 w-4 rounded-full shadow-lg"
                                style={{ backgroundColor: `hsl(${theme.colors.primary})` }}
                            />
                            <div
                                className="h-4 w-4 rounded-full shadow-lg"
                                style={{ backgroundColor: `hsl(${theme.colors.accent})` }}
                            />
                            <div
                                className="h-4 w-4 rounded-full shadow-lg"
                                style={{ backgroundColor: `hsl(${theme.colors.background})` }}
                            />
                        </div>
                        <span className="font-display text-xs font-bold">{theme.label}</span>
                    </div>
                    {preferences.theme === theme.name && (
                        <div className="absolute top-2 right-2 rounded-full bg-primary p-1 text-primary-foreground shadow-lg">
                            <Check className="h-3 w-3" />
                        </div>
                    )}
                </Button>
            ))}
        </div>
    );
}
